const e = (l, n) => [null, void 0, ""].includes(l) ? n : l;
export {
  e as getValByDef
};
//# sourceMappingURL=getValByDef.mjs.map
